export function WarningsStrip({ warnings }: { warnings: string[] }) {
  if (!warnings.length) return null;
  return (
    <div class="dash-warnings mono" role="status">
      {warnings.map((w) => <div key={w} class="warn">⚠ {w}</div>)}
    </div>
  );
}
